import axios from 'axios'
import PadraoService from '@/modules/services/padrao.service'
import MensagensHelper, { MSG_SUCESSO } from '@/utils/mensagens.helper'
import * as msg from '../mensagens/usuario.msg'

import ApiRotas from '@/modules/services/rotas.api'
import ServiceHandler from '@/modules/services/handler/service.handler'

class UsuarioService extends PadraoService {
  constructor() {
    // Rota, Biblioteca de mensagens
    super('usuarios', msg)
  }

  async atualizarPerfil(dados) {
    try {
      await axios.put(`${ApiRotas}/${this.rota}/perfil`, dados)
      return MensagensHelper.gerar(MSG_SUCESSO, this.msgs.ATUALIZADO)
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  }

  async retornaTodosBarbeiros(pagina = 0) {
    const params = pagina === 0 ? {} : { params: { p: pagina } }
    try {
      const retorno = await axios.get(`${ApiRotas}/${this.rota}/filtro/barbeiros`, params)
      if (retorno.data) {
        return retorno.data
      }

      throw MensagensHelper.gerar(msg, this.msgs.NAO_ENCONTRADO)
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  }

  async resetarSenha(dados) {
    try {
      await axios.put(`${ApiRotas}/${this.rota}/resetarsenha`, dados)
      return MensagensHelper.gerar(MSG_SUCESSO, this.msgs.SENHA_RESETADA)
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  }
}

export default new UsuarioService()
